import 'lazysizes/plugins/bgset/ls.bgset';
import lazySizes from "lazysizes";
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import $ from "./lib/jquery";
lazySizes.init();